import ApiClient from '@/services/apiClient';
import i18n from '@/i18n';

const t = (key, params) => i18n.global.t(key, params);

export default class MfaInfo {
    method;
    address;
    // Approval on a phone (method "push"): the sign-in request the phone must
    // answer with the person's biometrics.
    challenge_id;
    expires_at;

    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MfaInfo();
            obj.method = ApiClient.convertToType(data['method'], 'String');
            obj.address = ApiClient.convertToType(data['address'], 'String');
            obj.challenge_id = ApiClient.convertToType(data['challenge_id'], 'String');
            obj.expires_at = ApiClient.convertToType(data['expires_at'], 'String');
        }
        return obj;
    }

    get message() {
        switch (this.method) {
            case "sms":
                return t('models.mfa.sms', { address: this.address });
            case "email":
                return t('models.mfa.email', { address: this.address });
            case "totp":
                return t('models.mfa.totp');
            case "push":
                return t('models.mfa.push');
            default:
                return t('models.mfa.unmanaged', { method: this.method });
        }
    }
}
